<style scoped>
.date-range > input {
  width: 80px !important;
}

.red-icon {
  color: #b03236;
}
</style>
<template lang="pug">
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        a Settings
  .row
    .col.s12
      ul.collapsible(data-collapsible='accordion', ref='collapsible')
        li
          .collapsible-header
            i.material-icons.red-icon settings
            | General
          .collapsible-body
            app-general-settings
        li
          .collapsible-header
            i.material-icons.red-icon lock
            | Password
          .collapsible-body
            app-password-settings
        //- li
          .collapsible-header
            i.material-icons.red-icon local_shipping
            | Delivery Options
          .collapsible-body
            app-delivery-settings
        //- li
          div.collapsible-header
              i.material-icons whatshot
              | Third
          div.collapsible-body
</template>
<script>
import AppPasswordSettings from '@/components/app-settings-password'
import AppDeliverySettings from '@/components/app-settings-delivery'
import AppGeneralSettings from '@/components/app-settings-general'

export default {
  meta: {
    title: 'Settings'
  },
  data () {
    return {}
  },
  mounted () {
    this.$M.Collapsible.init(this.$refs.collapsible)
  },
  components: {
    AppPasswordSettings,
    AppDeliverySettings,
    AppGeneralSettings
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-settings.vue